<template>
  <div class="groupGoodList b_white">
    <div class="groupTabList b_white">
      <ul class="flex justify_around align_center">
        <li :class="{ 'tabActive' : tabActive === 1}" @click="tabActiveClick(1)">进行中</li>
        <li :class="{ 'tabActive' : tabActive === 2}" @click="tabActiveClick(2)">已结束</li>
      </ul>
    </div>
    <div class="groupList b_white" v-if="isEmptyGoods">
      <van-list
        v-model="myGroupLoading"
        :finished="finished"
        :immediate-check="false"
        :offset="20"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul>
          <template v-if="goodsList && goodsList.length > 0">
            <li class="clear" v-for="(goods, index) in goodsList" :key="index"
                @click="toMyDetail(goods.goodsId,goods.groupActivityId,goods.id,goods.activity.shopId)">
              <div class="collect_img relative mui-pull-left">
                <img v-lazy="`${goods.activityGoods.goodsEntity.picUrl}?imageMogr2/thumbnail/120000@`">
                <div class="good_mask flex_center" v-if="goods.groupStatus == '2'">拼团成功</div>
                <div class="good_mask flex_center" v-if="goods.groupStatus == '3'">拼团失败</div>
              </div>
              <div class="mui-media-body mui-pull-left collect_main">
                <h3 class="f13_rem yahei gray_3 lin_15 mui-ellipsis-2 ">
                  <span class="collect_icon">
                    <img src="./collect_icon.png" alt="" v-if="goods.sponsorBoId === userInfo.id">
                  </span>
                  <span>{{ goods.activityGoods.goodsEntity.name }}</span>
                  </h3>
                <div class="box10"></div>
                <p class="f10_rem gray_3">
                  {{goods.activity.startTimeStr.slice(0,10)}}
                  -
                  {{goods.activity.endTimeStr.slice(0,10)}}
                </p>
                <div class="box10"></div>
                <p class="lin_15">
                  <span class="red f14_rem fb">拼团价：¥ {{ goods.activityGoods.goodsPrice }}</span>
                  <span class="f10_rem gray_6 pad15_l">原价：¥ {{ goods.activityGoods.marketPrice }}</span>
                </p>
                <!--<h3 class="f13_rem yahei gray_3 lin_15 mui-ellipsis-2 ">{{ goods.activityGoods.goodsEntity.name }}</h3>-->
              </div>
            </li>
          </template>
        </ul>
      </van-list>
    </div>
    <div class="exclusive_none" v-else>
      <img src="../images/search_none.png" alt="">
      <p class="gray_9">暂无拼团</p>
    </div>
    <div class="group_btn">
      <p class="t_center f14_rem white btn_join" @click="toOrderSubmit">我要开团</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
import { mapState } from "vuex";
import common from "../../../assets/js/common";

export default {
  data() {
    return {
      tabActive: 1,
      isEmptyGoods: true,
      goodsList: [],
      pageNum: 1,
      finished: false,
      myGroupLoading: false,
      refreshing: false,
      shopId: ""
    };
  },
  created() {
    this.onRefresh();
    const { query } = this.$route;
    if (query.shopId) {
      this.shopId = query.shopId;
    }
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  methods: {
    toOrderSubmit() {
      this.$router.push(`/group/goodList?shopId=${this.shopId}`);
    },
    tabActiveClick(tabActive) {
      this.tabActive = tabActive;
      this.onRefresh();
    },
    onRefresh() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      const params = {
        pageNum: 1,
        pageSize: 8,
        statusList: this.tabActive === 1 ? [1] : [2, 3]
      };
      this.$store.dispatch("group/goods/queryMyGroupList", params).then((res) => {
        if (res.data && res.data.length > 0) {
          this.goodsList = res.data;
          this.isEmptyGoods = true;
          this.finished = false;
        } else {
          this.isEmptyGoods = false;
          this.finished = true;
        }
      });
    },
    onLoad() {
      if (this.goodsList.length === 0) {
        return;
      }
      this.myGroupLoading = true;
      this.pageNum += 1;
      const params = {
        pageNum: this.pageNum,
        pageSize: 8,
        statusList: this.tabActive === 1 ? [1] : [2, 3]
      };
      this.$store.dispatch("group/goods/queryMyGroupList", params).then((res) => {
        if (res.data && res.data.length) {
          this.goodsList = [...this.goodsList, ...res.data];
          this.myGroupLoading = false;
        } else {
          this.finished = true;
        }
      });
    },
    toMyDetail(id, activityId, groupId, shopId) {
      // this.$router.push(`/group/myGroupBook?shopId=${shopId}&goodsId=${id}&activityId=${activityId}&groupId=${groupId}`);
      window.location.href = `${process.env.VUE_APP_APP}vm/group/myGroupBook?shopId=${shopId}&goodsId=${id}&activityId=${activityId}&groupId=${groupId}`;
    }
  }
};
</script>
